import DataInForm from './data-in-form.json';


export default class ToolFormLoader {

    // -------------------------------------------------------------
    // Properties

    public formData: any = DataInForm;

}
